import vector1 from '../images/education/Vector.svg'
import vector2 from '../images/education/Vector_2.svg'
import vector3 from '../images/education/Vector_3.svg'
import vector4 from '../images/education/Vector_4.svg'
import vector5 from '../images/education/Vector_5.svg'
import vector6 from '../images/education/Vector_6.svg'
import vector7 from '../images/education/Vector_7.svg'
import vector8 from '../images/education/Vector_8.svg'

export const educationSliderInformation = [
  {
    id: 1,
    title: 'Научная карьера',
    img: vector1,
    text: 'Выполнение и защита диссертаций на базе проектов Generium'
  },
  {
    id: 2,
    title: 'Нацеленность на результат',
    img: vector2,
    text: 'Воплощение научных идей и разработок в реальные проекты и технологии'
  },
  {
    id: 3,
    title: 'Передовые технологии',
    img: vector3,
    text: 'Разработка любого биотехнологического препарата от создания молекулы до начала промышленного выпуска'
  },
  // {
  //   id: 4,
  //   title: 'Конкурентные условия',
  //   img: vector4,
  //   text: 'Ежегодное премирование и индексация оклада'
  // },
  {
    id: 5,
    title: 'Предоставление жилья',
    img: vector5,
    text: 'На период стажировки в зависимости от плана программы'
  },
  {
    id: 6,
    title: 'Все включено',
    img: vector6,
    text: 'Корпоративные обеды, фитнес с бассейном на территории академгородка'
  },
  {
    id: 7,
    title: 'Сильная команда',
    img: vector7,
    text: 'Сообщество профессионалов мирового уровня'
  },
  {
    id: 8,
    title: 'Корпоративный досуг',
    img: vector8,
    text: 'Спортивные команды и клубы по интересам'
  }
]
